import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';

//import styled from 'styled-components';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getFaq } from '../../../../services/fornecedoresDAF/faqService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  swalSave,
  swalAtualizacao,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swal,
} from '../../../../utils/swal';

const topicoComunicacaoOptions = [
  { value: 0, label: 'Não informado' },
  { value: 1, label: 'Contrato' },
  { value: 2, label: 'Entrega de produto farmacêutico' },
  { value: 3, label: 'Nota fiscal' },
  { value: 4, label: 'Pregão elêtronico' },
  { value: 5, label: 'Processo de incorporação' },
  { value: 6, label: 'Outro' },
];

export default function FaqFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  let subAbas = [];
  if (fichaID != 'undefined') {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/fornecedores/faq/ficha/${fichaID}/dadosgerais`,
      },
    ];
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/fornecedores/faq/ficha/dadosgerais`,
      },
    ];
  }

  const [data, setData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
    topicoComunicacao: 0,
    outroTopico: '',
    contexto: '',
    respostaEncaminhamento: '',
    observacoes: '',
  });

  const [formFaq, setFormFaq] = useState({
    topicoComunicacao: 0,
    outroTopico: '',
    contexto: '',
    respostaEncaminhamento: '',
    observacoes: '',
    usuarioRegistroId: userID,
  });

  let logs = {};

  const fetchData = async (id: string) => {
    try {
      const faqData = await getFaq(id);
      setData(faqData);
      setFormFaq({
        usuarioRegistroId: userID,
        topicoComunicacao: faqData.topicoComunicacao,
        outroTopico: faqData.outroTopico,
        contexto: faqData.contexto,
        respostaEncaminhamento: faqData.respostaEncaminhamento,
        observacoes: faqData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  if (fichaID !== 'undefined') {
    useEffect(() => {
      fetchData(fichaID);
    }, []);
    logs = {
      id: data.id,
      usuarioRegistro: data.usuarioRegistro.nomeCompleto,
      usuarioAtualizacao: data.usuarioAtualizacao.nomeCompleto,
      dataRegistro: data.dataRegistro,
      dataAtualizacao: data.dataUltimaAtualizacao,
      nEdicoes: data.nEdicoes,
    };
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'topicoComunicacao') {
      const newValue = parseInt(value, 10);
      setFormFaq({
        ...formFaq,
        topicoComunicacao: newValue,
      });

      if (newValue === 6) {
        setFormFaq((prev) => ({ ...prev, outroTopico: '' }));
      } else {
        setFormFaq((prev) => ({ ...prev, outroTopico: '' }));
      }
    } else {
      setFormFaq((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.topicoComunicacao) {
      errors.push('Tópico da comunicação é obrigatório.');
    }

    if (form.topicoComunicacao === 6 && form.outroTopico === '') {
      errors.push('Outro Tópico da comunicação é obrigatório.');
    }

    if (!form.contexto) {
      errors.push('Contexto da comunicação é obrigatório.');
    }

    if (!form.respostaEncaminhamento) {
      errors.push('Resposta/Encaminhamento é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };
  const adjustFormBeforeSubmit = (form: any) => {
    const {} = form;

    return {
      // Adicione ajustes necessários aqui
      observacoes: form.observacoes || 'Nenhuma observação específica.',
    };
  };

  const handleCreate = async () => {
    try {
      const isFormValid = validateForm(formFaq);
      if (!isFormValid) return;

      const adjustedForm = adjustFormBeforeSubmit(formFaq);

      const response = await httpClient.post(`/api/faq/`, formFaq);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/fornecedores/faq/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      const isFormValid = validateForm(formFaq);
      if (!isFormValid) return;

      const adjustedForm = adjustFormBeforeSubmit(formFaq);

      const response = await httpClient.patch(`/api/faq/${fichaID}`, formFaq);

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/faq/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/fornecedores/faq');
      } catch (error) {
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/fornecedores/faq"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_FAQ" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Dados do FAQ">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="30%">
                <SelectInput
                  name="topicoComunicacao"
                  options={[...topicoComunicacaoOptions]}
                  label="Tópico"
                  value={formFaq.topicoComunicacao}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="outroTopico"
                  name="outroTopico"
                  value={formFaq.outroTopico}
                  label="Outro Tópico"
                  onChange={handleChange}
                  readonly={formFaq.topicoComunicacao !== 6}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="contexto"
                  name="contexto"
                  value={formFaq.contexto}
                  label="Contexto/Pergunta/Situação"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="respostaEncaminhamento"
                  name="respostaEncaminhamento"
                  value={formFaq.respostaEncaminhamento}
                  label="Resposta/Encaminhamento"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <BoxConteudo boxTitulo="Observações Gerais" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formFaq.observacoes}
                  label=""
                  type="textarea"
                  linhas={3}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
